import "./CollectorContent.scss";
import "./CollectorContentSearch.scss";
import "./CollectorContentViewAll.scss";

import CollectorContentPage from "./CollectorContent";
export { default as CollectorContentSearchPage } from "./CollectorContentSearch";
export { default as CollectorContentViewAllPage } from "./CollectorContentViewAll";
export { default as PostSearchTable } from "../../partials/post/PostSearchTable";

export default CollectorContentPage;